export const ligthTheme = {
  brand100: "#3d84f7",
  brand200: "#377af6",
  bgPrimary: "#ffffff",
  bgSecondary: "#e4e4e4",
  bgHover: "#dedede",
  textPrimary: "#262626",
  textSecondary: "#828282",
  borderPrimary: "#bebebe",
  borderSecondary: "#bebebe",
  buttonPrimary: "#ebebeb",
  inputPrimary: "#ffffff",
  inputSecondary: "#d8d8d8",
  inputBorder: "#717171",
  inputSearch: "#cecece",
  bgHeader: "#f1f1f1",
  borderHeader: "#e5e5e5",
  boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
  placeholder: "#989a9c",
  spinnerPrimary: "#303030",
  spinnerSecondary: "rgba(0, 0, 0, 0.24)",
};

export const darkTheme = {
  brand100: "#3d84f7",
  brand200: "#377af6",
  bgPrimary: "#1e1e1e",
  bgSecondary: "#303030",
  bgHover: "#404040",
  textPrimary: "#dadada",
  textSecondary: "#828282",
  borderPrimary: "#555555",
  borderSecondary: "#000000",
  buttonPrimary: "#504f4f",
  inputPrimary: "#2d2d2d",
  inputSecondary: "#252525",
  inputBorder: "#6a6a6a",
  inputSearch: "#373737",
  bgHeader: "#333334",
  borderHeader: "#0b0b0b",
  boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
  placeholder: "#989a9c",
  spinnerPrimary: "#ffffff",
  spinnerSecondary: "rgba(255, 255, 255, 0.5)",
};
